import * as React from 'react'
import { Card, Descriptions, Form, Input, Select } from 'antd'
import { setDeposit } from '../../edit/model'
import { path, role } from '../../../../../libs'
import { getRolesByGuardRules } from '../../../../../features/session/constants'
import { DepositEdit, ClientPurse } from '../../edit/types'

type Props = {
  deposit: DepositEdit
  clientPurses: ClientPurse[]
  userRole: string[] | undefined
}

export const DepositPaymentBlock = ({
  deposit,
  clientPurses,
  userRole,
}: Props) => {
  const isSupport =
    userRole != undefined &&
    (userRole.indexOf(role.clientSupport.supportAgent()) >= 0 ||
      userRole.indexOf(role.clientSupport.supportManager()) >= 0)

  const canEditGateway = getRolesByGuardRules('edit_gateway').some((rule) =>
    userRole?.includes(rule),
  )

  const purse = deposit.clientPurse

  return (
    <Card size="small" title="Payment">
      <Form layout="vertical">
        <Form.Item label="Exchange rate">
          <Input
            value={deposit.exchangeRate}
            disabled={isSupport}
            onChange={(event) =>
              setDeposit({ ...deposit, exchangeRate: event.target.value })
            }
          />
        </Form.Item>

        <Form.Item label="Client purse ID">
          <Select
            value={deposit.clientPurseId?.toString()}
            disabled={isSupport}
            onChange={(value) =>
              setDeposit({ ...deposit, clientPurseId: Number(value) })
            }
            options={clientPurses.map((item) => ({
              value: item.id?.toString(),
              label: `${item.mask} is card: ${item.isCard} verified: ${item.verified}`,
            }))}
          />
        </Form.Item>
      </Form>

      <Descriptions size="small" column={{ xs: 1, sm: 2 }} bordered>
        <Descriptions.Item label="Processing provider">
          {deposit.processingProvider}
        </Descriptions.Item>
        <Descriptions.Item label="Provider ID">
          {deposit.providerId}
        </Descriptions.Item>
        {deposit.gateway?.internalName && (
          <Descriptions.Item label="Gateway">
            {deposit.gateway.gatewayId &&
              (canEditGateway ? (
                <a
                  href={path.billing.gateway.edit(
                    deposit.gateway.gatewayId.toString(),
                  )}
                  target="_blank"
                >
                  {deposit.gateway.gatewayId}
                </a>
              ) : (
                <span>{deposit.gateway.gatewayId}</span>
              ))}{' '}
            {deposit.gateway.internalName}
          </Descriptions.Item>
        )}
        {purse && (
          <>
            <Descriptions.Item label="Purse mask">
              {purse.mask}
            </Descriptions.Item>
            <Descriptions.Item label="Purse expiry">
              {purse.expiry}
            </Descriptions.Item>
            <Descriptions.Item label="Purse type">
              {purse.type}
            </Descriptions.Item>
            <Descriptions.Item label="Purse verified">
              {purse.verified ? 'yes' : 'no'}
            </Descriptions.Item>
          </>
        )}
      </Descriptions>
    </Card>
  )
}
